/* ==========================================================
   VECTOR COMPONENT VC-007
   IMAGE GALLERY PRO
   Final Version: 1.2
   ========================================================== */

class VectorGallery {
  constructor(gallery) {
    this.gallery = gallery;

    if (
      !this.gallery ||
      this.gallery.classList.contains('vector-gallery-ready')
    ) {
      return;
    }

    this.init();
  }

  init() {
    this.gallery.classList.add('vector-gallery-ready');

    console.log('VC-007 Image Gallery Pro Loaded');
  }
}

function initialiseVectorGalleries(root = document) {
  root.querySelectorAll('media-gallery').forEach((gallery) => {
    new VectorGallery(gallery);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initialiseVectorGalleries();
});

/* Reload correctly inside the Shopify theme editor */

document.addEventListener('shopify:section:load', (event) => {
  initialiseVectorGalleries(event.target);
});

/* ==========================================================
   END VC-007
   ========================================================== */